import { DATE_FORMATS } from "@/constants";
import { useDisclosure } from "@/hooks";
import { Button, Flex, Image, Modal } from "antd";
import dayjs from "dayjs";
import { AiOutlineEye } from "react-icons/ai";

export function PostDetailModal(props: Post) {

    const [opened, { toggle }] = useDisclosure(false);

    const { title, body, images, publishedAt, createdAt } = props;

    return (
        <>
            <Button
                icon={<AiOutlineEye />}
                className="bg-primary-gradient"
                type="primary"
                shape="round"
                onClick={toggle}
            >
                Detail
            </Button>
            <Modal
                open={opened}
                onCancel={toggle}
                footer={null}
                width={640}
                title={title}
                centered
                classNames={{
                    header: "[&>.ant-modal-title]:!text-xl [&>.ant-modal-title]:!font-poppins",
                    body: "max-h-[500px] min-h-[300px] overflow-y-auto !py-4",
                }}
            >
                {
                    images && images.length > 0 && (
                        <div
                            className="flex flex-nowrap overflow-x-scroll items-stretch gap-3 border rounded border-gray-100 p-2"
                        >
                            {
                                images.map((image, index) => (
                                    <div
                                        key={image.id}
                                        className="relative shrink-0"
                                    >
                                        <Image
                                            src={image.url}
                                            alt={`Post image ${index + 1}`}
                                            // width={250}
                                            height={280}
                                            className="rounded-md max-h-[280px] h-full w-full object-cover"
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    )
                }

                <article className="mt-4">
                    <Flex
                        justify="space-between"
                    >
                        {
                            createdAt && (
                                <p className="text-sm text-gray-500 mb-2">
                                    Created on: {dayjs(createdAt).format(DATE_FORMATS.DAY_MONTH_FORMAT)}
                                </p>
                            )
                        }
                        {
                            publishedAt && (
                                <p className="text-sm text-gray-500 mb-2">
                                    Published on: {dayjs(publishedAt).format(DATE_FORMATS.DAY_MONTH_FORMAT)}
                                </p>
                            )
                        }
                    </Flex>
                    <p
                        className="text-base whitespace-pre-line"
                    >
                        {body}
                    </p>
                </article>
            </Modal>
        </>
    )
}
